import gql from 'graphql-tag';

export const CATALOG_COLLECTION_PAGE_QUERY = gql`
  query CatalogCollectionPageQuery($slug: String!) {
    CatalogCollectionPagesV1Resource {
      bySlug(slug: $slug) {
        elements {
          id
          title
          collection {
            entries {
              id
            }
          }
          s12ns {
            elements {
              id
              name
              slug
              logo
              productVariant
              courseIds
              metadata {
                level
              }
              derivativeV2: derivative {
                id
                ratingCount
                averageFiveStarRating
                avgLearningHoursAdjusted
              }
              partners {
                elements {
                  id
                  name
                  squareLogo
                  classLogo
                  logo
                }
              }
            }
          }
          courses {
            elements {
              id
              name
              slug
              level
              photoUrl
              courseDerivativesV2 {
                id
                ratingCount
                averageFiveStarRating
                avgLearningHoursAdjusted
              }
              partners {
                elements {
                  id
                  name
                  squareLogo
                  classLogo
                  logo
                }
              }
            }
          }
        }
      }
    }
  }
`;
